import AgTechNoRecordsPage, { AgTechNoRecordsPageProps } from '../../Pages/Error/AgTechNoRecordsPage';
import React from 'react'

export type AgTechCardCollectionSettings = {
    header?: () => React.ReactNode,
    headerContent?: () => React.ReactNode,
    footer?: React.ReactNode,
    maxCardWidth?: string,
    title?: string,
    classes?: string,
    noRecordConfig?: AgTechNoRecordsPageProps,
    gridTemplateColumns?: string
}

export type AgTechCardCollectionProps<TEntity> = {
    card: (entity: TEntity) => React.ReactNode,
    entities: TEntity[],
    settings?: AgTechCardCollectionSettings
};

let AgTechCardCollection = <TEntity,>(props: AgTechCardCollectionProps<TEntity>) => {

    let cardCollectionHeader = () => {
        if (props.settings?.header) {
            return (
                <div className="wide pb-4 px-1 flex">
                    {props.settings.header()}
                </div>
            );
        }
        else if (props.settings?.title) {
            return (
                <div className="agtech-card-collection-header agtech-columns-container agtech-vertically-centered-container">
                    {props.settings.title}
                    { props.settings?.headerContent ? (
                        <div className='ml-auto container'>
                            {props.settings.headerContent()}
                        </div>
                    ) : null }
                </div>
            )
        }
        else {
            return null;
        }
    }

    return props.entities.length > 0 ? (
        <div className={`row-based stretched non-scrollable container`}>
            {cardCollectionHeader()}
            <div
                className={`scrollable grid grid-gap-3 ${props.settings?.classes ?? ''}`}
                style={{ gridTemplateColumns: props.settings?.gridTemplateColumns ?? `repeat(auto-fill, ${props.settings?.maxCardWidth ?? '300px'})` }}
            >
                {props.entities.map(entity => props.card(entity))}
            </div>
            {props.settings?.footer ?
                <div className="agtech-card-collection-footer">
                    {props.settings?.footer}
                </div>
                : null
            }
        </div>
    ) : props.settings?.noRecordConfig ? (
        <AgTechNoRecordsPage {...props.settings?.noRecordConfig} />
    ) : null;
};

export const AgTechTwoColumnCardCollection = <TEntity, >(props: AgTechCardCollectionProps<TEntity>) => {
    return (
        <AgTechCardCollection
            {...props}
            settings={{
                maxCardWidth: '48%',
                classes: 'horizontally-centered'
            }}
        />
    )
}

export default AgTechCardCollection;